export function ReadOnlyFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.907 2.725a3 3 0 00-4.206.554l-.912 1.188L11.3 2.6 8.103 6.863l1.585 1.22L11.7 5.4l.872.654-2.05 2.67 4.756 3.659 2.033-2.65L13.4 6.8a1 1 0 111.2-1.6l3.929 2.947.932-1.215a3 3 0 00-.554-4.207zM6.2 14.359l1.887-2.46 4.756 3.657-1.883 2.455a3.001 3.001 0 01-3.252 1.045L7 20h12a1 1 0 110 2H3l3.097-4.13a3.001 3.001 0 01.102-3.511zM5.61 6.207a1 1 0 10-1.22 1.586l13 10a1 1 0 101.22-1.586l-13-10z"
      ></path>
    </svg>
  );
}
